export default __webpack_public_path__ + "static/O0152-9c143880c98e31b3e42e7a72b7fcb421.png";